"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = require("@/utils/format");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const timePeriods = [
    { title: "1W", value: 7 },
    { title: "2W", value: 14 },
    { title: "1M", value: 30 },
    { title: "2M", value: 60 },
    { title: "1Y", value: 365 },
];
const LineGraph = ({ data, title, color = "#61AD37" }) => {
    const [currentDataset, setCurrentDataset] = (0, react_1.useState)([]);
    const [currentPeriod, setCurrentPeriod] = (0, react_1.useState)(7);
    const [keysLegend, setKeysLegend] = (0, react_1.useState)([]);
    const [valuesLegend, setValuesLegend] = (0, react_1.useState)([]);
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    (0, react_1.useEffect)(() => {
        const val = Object.values(data).map((v) => parseFloat(String(v)));
    }, [data]);
    (0, react_1.useEffect)(() => {
        const date = new Date();
        date.setDate(date.getDate() - currentPeriod);
        const filteredData = Object.keys(data).filter((k) => parseInt(k) * 1000 > date.getTime());
        const val = filteredData.map((v) => data[v]);
        const valueStep = Math.floor((Math.max(...val) - Math.min(...val)) / 4);
        const vKeys = [];
        for (let i = 0; i < 5; i += 1) {
            vKeys.push(Math.max(...val) - valueStep * i);
        }
        setValuesLegend(vKeys);
        const dates = filteredData.map((v) => parseInt(v) * 1000);
        const timeStep = Math.floor((new Date(dates[dates.length - 1]).getTime() - new Date(dates[0]).getTime()) / 6);
        const lKeys = [];
        for (let i = 0; i < 7; i += 1) {
            lKeys.push(new Date(dates[0] + timeStep * i));
        }
        setKeysLegend(lKeys.map((v) => v.toLocaleString('default', { month: 'short', day: "numeric", })));
        console.log(val);
        setCurrentDataset(val);
    }, [currentPeriod]);
    console.log(isDarktheme, "isDarktheme");
    return (react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", style: { margin: "20px 0" } },
        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: "space-between", align: "center" },
            react_1.default.createElement(origyn_art_ui_1.Flex, null,
                react_1.default.createElement("h3", null, title)),
            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16 }, timePeriods.map((v) => (react_1.default.createElement(origyn_art_ui_1.Button, { size: "medium", className: `${v.value === currentPeriod ? "hover" : ""}`, onClick: () => setCurrentPeriod(v.value) }, v.title))))),
        react_1.default.createElement(GraphAxis, { horizontalKeys: keysLegend, verticalLegend: valuesLegend },
            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, fullHeight: true, justify: "space-between" },
                react_1.default.createElement(StyledGraphColumnsWrapper, { isDarktheme: !!isDarktheme, color: color }, currentDataset.map((v) => (react_1.default.createElement("div", { className: "column", style: { width: `calc((100% / ${currentPeriod}) - ${currentPeriod > 60 ? "0" : "2"}px)` } },
                    react_1.default.createElement("div", { style: { height: `${105 - ((Math.max(...currentDataset) - v) / (Math.max(...currentDataset) - Math.min(...currentDataset))) * 100}%` } })))))))));
};
const GraphAxis = ({ horizontalKeys, verticalLegend, children }) => {
    return (react_1.default.createElement(AxisWrapper, null,
        react_1.default.createElement(VerticalLegend, null, verticalLegend.map((v) => (react_1.default.createElement("div", { title: v }, (0, format_1.shortenNumber)(v))))),
        react_1.default.createElement(AxisBlock, null,
            react_1.default.createElement("div", { className: "pointerLine", style: { top: "20px" } }),
            react_1.default.createElement("div", { className: "pointerLine", style: { top: "30%" } }),
            react_1.default.createElement("div", { className: "pointerLine", style: { top: "52%" } }),
            react_1.default.createElement("div", { className: "pointerLine", style: { top: "75%" } }),
            children),
        react_1.default.createElement(HorizontalLegend, null, horizontalKeys.map((v) => (react_1.default.createElement("div", { title: v }, v))))));
};
const StyledGraphColumnsWrapper = styled_components_1.default.div `
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;

    .column {

    max-width: 44px;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 22px 22px 0 0;

    background-color: ${({ isDarktheme }) => isDarktheme ? "#2C2C2E" : "#E1E3EC"};

        > div {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            content: "";
            display: block;
            background-color: ${({ color }) => color};
            min-height: 5%;
            max-height: 94%;
        }
    }   
`;
const StyledGraphColumn = styled_components_1.default.div `
    max-width: 44px;
    height: 100%;
    position: relative;
    overflow: hidden;
    width: calc((100% / ${({ columns }) => columns}) - ${({ columns }) => columns > 60 ? "0" : "2"}px);
    border-radius: 22px 22px 0 0;

    background-color: #2C2C2E;

    &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${({ filling }) => filling}%;
        content: "";
        disaply: block;
        background-color: #61AD37;
        min-height: ${({ columns }) => columns > 10 ? "2%" : "10%"};
        max-height: ${({ columns }) => columns > 10 ? "98%" : "95%"};
    }
`;
const HorizontalLegend = styled_components_1.default.div `
    position: absolute;
    right: 0;
    bottom: 0;

    width: 100%;
    justify-content: space-between;
    padding: 0 2px 10px 50px;
    display: flex;
    > div {
        padding: 4px;
        cursor: default;
    }
`;
const VerticalLegend = styled_components_1.default.div `
    position: absolute;
    left: 0;
    top: 0;

    height: 100%;
    justify-content: space-between;
    padding: 30px 0 40px 0;
    display: flex;
    flex-flow: column;
    > div {
        cursor: default;
    }
`;
const AxisBlock = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: 250px;

    border-bottom: 1px solid #242424;

    .pointerLine {
        position: absolute;
        width: 100%;
        left: 0;
        height: 1px;
        background: repeating-linear-gradient(90deg, #242424 0 10px,#0000 0 14px);
    }
`;
const AxisWrapper = styled_components_1.default.div `
    padding: 20px 0 40px 50px;
    position: relative;
    font-size: 12px;
`;
exports.default = LineGraph;
